export const ERC20CappedMintablePremintBurnablePausable = {
  _format: "hh-sol-artifact-1",
  contractName: "ERC20CappedMintablePremintBurnablePausable",
  sourceName: "contracts/templates/ERC20CappedMintablePremintBurnablePausable.sol",
  abi: [
    {
      inputs: [
        {
          internalType: "string",
          name: "name",
          type: "string",
        },
        {
          internalType: "string",
          name: "symbol",
          type: "string",
        },
        {
          internalType: "address",
          name: "initialOwner",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "premint",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "cap",
          type: "uint256",
        },
      ],
      stateMutability: "payable",
      type: "constructor",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "increasedSupply",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "cap",
          type: "uint256",
        },
      ],
      name: "ERC20ExceededCap",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "allowance",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "needed",
          type: "uint256",
        },
      ],
      name: "ERC20InsufficientAllowance",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "sender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "balance",
          type: "uint256",
        },
        {
          internalType: "uint256",
          name: "needed",
          type: "uint256",
        },
      ],
      name: "ERC20InsufficientBalance",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "approver",
          type: "address",
        },
      ],
      name: "ERC20InvalidApprover",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "cap",
          type: "uint256",
        },
      ],
      name: "ERC20InvalidCap",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "receiver",
          type: "address",
        },
      ],
      name: "ERC20InvalidReceiver",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "sender",
          type: "address",
        },
      ],
      name: "ERC20InvalidSender",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "ERC20InvalidSpender",
      type: "error",
    },
    {
      inputs: [],
      name: "EnforcedPause",
      type: "error",
    },
    {
      inputs: [],
      name: "ExpectedPause",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
      ],
      name: "OwnableInvalidOwner",
      type: "error",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "OwnableUnauthorizedAccount",
      type: "error",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Approval",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "previousOwner",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "OwnershipTransferred",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Paused",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: true,
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          indexed: true,
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          indexed: false,
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "Transfer",
      type: "event",
    },
    {
      anonymous: false,
      inputs: [
        {
          indexed: false,
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "Unpaused",
      type: "event",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "owner",
          type: "address",
        },
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
      ],
      name: "allowance",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "spender",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "approve",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
      ],
      name: "balanceOf",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "burn",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "account",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "burnFrom",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "cap",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "decimals",
      outputs: [
        {
          internalType: "uint8",
          name: "",
          type: "uint8",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "amount",
          type: "uint256",
        },
      ],
      name: "mint",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "moontools",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "name",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "owner",
      outputs: [
        {
          internalType: "address",
          name: "",
          type: "address",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "pause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "paused",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "price",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "renounceOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "symbol",
      outputs: [
        {
          internalType: "string",
          name: "",
          type: "string",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [],
      name: "totalSupply",
      outputs: [
        {
          internalType: "uint256",
          name: "",
          type: "uint256",
        },
      ],
      stateMutability: "view",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "transfer",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "from",
          type: "address",
        },
        {
          internalType: "address",
          name: "to",
          type: "address",
        },
        {
          internalType: "uint256",
          name: "value",
          type: "uint256",
        },
      ],
      name: "transferFrom",
      outputs: [
        {
          internalType: "bool",
          name: "",
          type: "bool",
        },
      ],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [
        {
          internalType: "address",
          name: "newOwner",
          type: "address",
        },
      ],
      name: "transferOwnership",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
    {
      inputs: [],
      name: "unpause",
      outputs: [],
      stateMutability: "nonpayable",
      type: "function",
    },
  ],
  bytecode:
    "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",
  deployedBytecode:
    "0x608060405234801561001057600080fd5b50600436106101075760003560e01c806306fdde031461010c578063095ea7b31461012a57806318160ddd1461014d57806323b872dd1461015f578063313ce56714610172578063355274ea146101815780633f4ba83a1461018957806340c10f191461019357806342966c68146101a65780635c975abb146101b957806370a08231146101c4578063715018a6146101ed57806379cc6790146101f55780638456cb59146102085780638da5cb5b1461021057806395d89b4114610225578063a035b1fe1461022d578063a9059cbb14610236578063cf4a520314610249578063dd62ed3e1461025c578063f2fde38b1461026f575b600080fd5b610114610282565b6040516101219190610977565b60405180910390f35b61013d6101383660046109e2565b610314565b6040519015158152602001610121565b6002545b604051908152602001610121565b61013d61016d366004610a0c565b61032e565b60405160128152602001610121565b610151610352565b610191610376565b005b6101916101a13660046109e2565b610388565b6101916101b4366004610a48565b61039e565b60055460ff1661013d565b6101516101d2366004610a61565b6001600160a01b031660009081526020819052604090205490565b6101916103ab565b6101916102033660046109e2565b6103bd565b6101916103d2565b6102186103e2565b6040516101219190610a83565b6101146103f6565b61015160075481565b61013d6102443660046109e2565b610405565b600654610218906001600160a01b031681565b61015161026a366004610a97565b610413565b61019161027d366004610a61565b61043e565b60606003805461029190610aca565b80601f01602080910402602001604051908101604052809291908181526020018280546102bd90610aca565b801561030a5780601f106102df5761010080835404028352916020019161030a565b820191906000526020600020905b8154815290600101906020018083116102ed57829003601f168201915b5050505050905090565b600033610322818585610482565b60019150505b92915050565b60003361033c858285610494565b6103478585856104e7565b506001949350505050565b7f000000000000000000000000000000000000000000000000000000000000000090565b61037e610546565b610386610578565b565b610390610546565b61039a82826105c4565b5050565b6103a833826105fa565b50565b6103b3610546565b6103866000610630565b6103c8823383610494565b61039a82826105fa565b6103da610546565b61038661068a565b60055461010090046001600160a01b031690565b60606004805461029190610aca565b6000336103228185856104e7565b6001600160a01b03918216600090815260016020908152604080832093909416825291909152205490565b610446610546565b6001600160a01b038116610479576000604051631e4fbdf760e01b81526004016104709190610a83565b60405180910390fd5b6103a881610630565b61048f83838360016106c7565b505050565b60006104a08484610413565b905060001981146104e157818110156104d257828183604051637dc7a0d960e11b815260040161047093929190610b04565b6104e1848484840360006106c7565b50505050565b6001600160a01b038316610511576000604051634b637e8f60e11b81526004016104709190610a83565b6001600160a01b03821661053b57600060405163ec442f0560e01b81526004016104709190610a83565b61048f83838361079c565b3361054f6103e2565b6001600160a01b031614610386573360405163118cdaa760e01b81526004016104709190610a83565b6105806107a7565b6005805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516105ba9190610a83565b60405180910390a1565b6001600160a01b0382166105ee57600060405163ec442f0560e01b81526004016104709190610a83565b61039a6000838361079c565b6001600160a01b038216610624576000604051634b637e8f60e11b81526004016104709190610a83565b61039a8260008361079c565b600580546001600160a01b03838116610100818102610100600160a81b031985161790945560405193909204169182907f8be0079c531659141344cd1fd0a4f28419497f9722a3daafe3b4186f6b6457e090600090a35050565b6106926107ca565b6005805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a2586105ad3390565b6001600160a01b0384166106f157600060405163e602df0560e01b81526004016104709190610a83565b6001600160a01b03831661071b576000604051634a1406b160e11b81526004016104709190610a83565b6001600160a01b03808516600090815260016020908152604080832093871683529290522082905580156104e157826001600160a01b0316846001600160a01b03167f8c5be1e5ebec7d5bd14f71427d1e84f3dd0314c0f7b2291e5b200ac8c7c3b9258460405161078e91815260200190565b60405180910390a350505050565b61048f8383836107ee565b60055460ff1661038657604051638dfc202b60e01b815260040160405180910390fd5b60055460ff16156103865760405163d93c066560e01b815260040160405180910390fd5b6107f66107ca565b61048f838383610807838383610860565b6001600160a01b03831661048f57600061081f610352565b9050600061082c60025490565b9050818111156108595760405163279e7e1560e21b81526004810182905260248101839052604401610470565b5050505050565b6001600160a01b03831661088b5780600260008282546108809190610b25565b909155506108ea9050565b6001600160a01b038316600090815260208190526040902054818110156108cb5783818360405163391434e360e21b815260040161047093929190610b04565b6001600160a01b03841660009081526020819052604090209082900390555b6001600160a01b03821661090657600280548290039055610925565b6001600160a01b03821660009081526020819052604090208054820190555b816001600160a01b0316836001600160a01b03167fddf252ad1be2c89b69c2b068fc378daa952ba7f163c4a11628f55a4df523b3ef8360405161096a91815260200190565b60405180910390a3505050565b60006020808352835180602085015260005b818110156109a557858101830151858201604001528201610989565b506000604082860101526040601f19601f8301168501019250505092915050565b80356001600160a01b03811681146109dd57600080fd5b919050565b600080604083850312156109f557600080fd5b6109fe836109c6565b946020939093013593505050565b600080600060608486031215610a2157600080fd5b610a2a846109c6565b9250610a38602085016109c6565b9150604084013590509250925092565b600060208284031215610a5a57600080fd5b5035919050565b600060208284031215610a7357600080fd5b610a7c826109c6565b9392505050565b6001600160a01b0391909116815260200190565b60008060408385031215610aaa57600080fd5b610ab3836109c6565b9150610ac1602084016109c6565b90509250929050565b600181811c90821680610ade57607f821691505b602082108103610afe57634e487b7160e01b600052602260045260246000fd5b50919050565b6001600160a01b039390931683526020830191909152604082015260600190565b8082018082111561032857634e487b7160e01b600052601160045260246000fdfea2646970667358221220224e8dbc83db7b07f76ba7c6636686e0531119e012c6e60e57a198fe385534bc64736f6c63430008180033",
  linkReferences: {},
  deployedLinkReferences: {},
};
